<script>
export default {
  props: {
    header: {
      type: String,
      default: undefined
    }
  },

  render() {
    return (
      <div>
        <div class={this.$style.header}>{this.header}</div>
        {this.$slots.default && (
          <ul class={this.$style.list}>{this.$slots.default}</ul>
        )}
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.header {
  color: #4d3206;
  font-size: 1rem;
  text-align: center;
  background-color: #ffc11d;
  border-radius: 0.25rem;
  padding: 0.5rem;
}

.list {
  list-style: none;
  padding: 0;
}
</style>
